// import React, { useEffect, useState } from 'react'
// import './Examranklist.css';
// import axios from 'axios';
// const SectionSelector = () => {
//        const [loading, setLoading] = useState(true);
//   useEffect(() => {
//     const timer = setTimeout(() => setLoading(false), 1000);
//     return () => clearTimeout(timer);
//   }, []);
//       const handleSectionClick = async (section) => {
//     const std = section === 'V to X' ? 'VI' : 'XI';
//     setStudentStd(std);
//     setSelectedSection(section);

//     try {
//       setLoading(true);
//       const response = await axios.get(`${process.env.REACT_APP_API}/questions/examdata?section=${section}`);
//       setExamDetails(response.data);
//     } catch (error) {
//       console.error('Error fetching exam data:', error);
//       setExamDetails([]);
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//        <div className="examrank-container">
//        <h2 className="examrank-title">📊 Exam Rank List</h2>

//       {loading ? (
//         <p className="loading-text">Loading...</p>
//       ) : (
//         <>
//           <div className="examrank-section" onClick={() => handleSectionClick('V to X')}>
//             <h4 className="examrank-header">V to X</h4>
//           </div>
//           <div className="examrank-section" onClick={() => handleSectionClick('XI to PG')}>
//             <h4 className="examrank-header">XI to PG</h4>
//           </div>
//         </>
//       )}
//     </div>
//   )
// }

// export default SectionSelector





import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Examranklist.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';

// Helper: Check for higher classes
const isXIOrAbove = (standard) => {
  if (!standard) return false;
  const std = standard.toUpperCase().trim();
  return std.startsWith('XI') || std.startsWith('XII') || std.startsWith('UG') || std.startsWith('PG');
};

const SectionSelector = () => {
  const [loading, setLoading] = useState(true);
  const [examDetails, setExamDetails] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedExam, setSelectedExam] = useState(null);
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [studentstd, setStudentStd] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showFullImage, setShowFullImage] = useState(false);
  const [addPopup, setAddPopup] = useState(false);
  const [EditPopup, setEditPopup] = useState(false);
  const [selectedStudentForCertificate, setSelectedStudentForCertificate] = useState(null);
  const [certificateFile, setCertificateFile] = useState(null);
  const [certificatePrice, setCertificatePrice] = useState('');
  const [examdata, setexamdata] = useState(null);
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
   

const navi =useNavigate()

 useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);
  useEffect(() => {
    checkexist();
  }, []); // ✅ Only run on first mount


const checkexist = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/questions/checkcertifacateexist`);
    setexamdata(response.data);
  } catch (error) {
    console.log(error);
  }
};

  const handleSectionClick = async (section) => {
    const std = section === 'V to X' ? 'VI' : 'XI';
    setStudentStd(std);
    setSelectedSection(section);
      // console.log(std)
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API}/questions/examdata?section=${section}`);
      setExamDetails(response.data);
      // console.log(response.data)
    } catch (error) {
      console.error('Error fetching exam data:', error);
      setExamDetails([]);
    } finally {
      setLoading(false);
    }
  };

  const handleExamClick =  (examid, examTitle) => {
     navi('/exam_rank_list', { state: { examid, examTitle ,studentstd } });
  };

  const closeExamModal = () => {
    setSelectedSection(null);
    setExamDetails(null);
  };

  const closeResultsModal = () => {
    setSelectedExam(null);
    setResults([]);
    setError('');
  };

  const handleView = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/questions/viewexamresult/${id}`);
      setSelectedStudent(response.data);
    } catch (error) {
      console.error('Error fetching student details:', error);
    }
  };

  const closeStudentModal = () => {
    setSelectedStudent(null);
  };

  const handleAddCertificateClick = (Id) => {
    setSelectedStudentForCertificate(Id);
    setAddPopup(true);
  };

    const handleEditCertificateClick = (Id) => {
    setSelectedStudentForCertificate(Id);
    setEditPopup(true);
  };



  const handleCertificateSubmit = async () => {
  if (!certificateFile && !certificatePrice) {
    alert("Please fill all fields.");
    return;
  }

  const formData = new FormData();
  formData.append("id", selectedStudentForCertificate || ""); // optional
  if (certificateFile) formData.append("certificate", certificateFile);
  if (certificatePrice) formData.append("amount", certificatePrice);

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API}/questions/Addexamcertificate`,
      formData
    );
    alert(res.data.message);
    if (res.data.success) {
      setAddPopup(false);
      setCertificateFile(null);
      setCertificatePrice("");
    }
  } catch (err) {
    console.error("Failed to add certificate:", err);
    alert("Something went wrong. Please try again.");
  }
};




const handleCertificateEditSubmit = async () => {
  const id = selectedStudentForCertificate || "";
  const formData = new FormData();

  formData.append("id", id);

  if (certificateFile) {
    formData.append("certificate", certificateFile);
  }

  if (certificatePrice) {
    formData.append("amount", certificatePrice);
  }

  if (!certificateFile && !certificatePrice) {
    alert("Please provide a new certificate or amount to update.");
    return;
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API}/questions/Editexamcertificate/${id}`,
      formData
    );

    alert(res.data.message);

    if (res.data.success) {
      setEditPopup(false);
      setCertificateFile(null);
      setCertificatePrice("");
    }
  } catch (err) {
    console.error("Failed to update certificate:", err);
    alert("Something went wrong. Please try again.");
  }
};


  return (
    <div className="examrank-container">
      <h2 className="examrank-title">📊 Exam Rank List</h2>

      {loading ? (
        <p className="loading-text">Loading...</p>
      ) : (
        <>
          <div className="examrank-section" onClick={() => handleSectionClick('V to X')}>
            <h4 className="examrank-header">V to X</h4>
          </div>
          <div className="examrank-section" onClick={() => handleSectionClick('XI to PG')}>
            <h4 className="examrank-header">XI to PG</h4>
          </div>
        </>
      )}

      {/* Exam List Modal */}
      {selectedSection && examDetails && (
        <div className="examrank-modal">
          <div className="examrank-modal-content" style={{ maxWidth: '500px' }}>
            <span className="examrank-modal-close" onClick={closeExamModal}>&times;</span>
            <h3 className="examrank-modal-header">{selectedSection} Exams</h3>

            {examDetails.length > 0 ? (
              <ul className="examrank-list">
                {examDetails.map((examtype, index) => (
                  <li
                    key={examtype.id}
                    className={index % 2 === 0 ? 'gold' : 'silver'}
                    onClick={() => handleExamClick(examtype.id, examtype.title)}
                  >
                    <strong>{index + 1}. {examtype.title}</strong>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No exams available.</p>
            )}
          </div>
        </div>
      )}

   

      
    </div>
  );
};

export default SectionSelector;
